import React from "react";
import { Card, CardContent, Typography, Box, Divider } from "@mui/material";

export default function CreditAccountsList({ data }) {
  return (
    <Card sx={{ borderRadius: 2, border: "1px solid", borderColor: "divider", bgcolor: "background.default" }}>
      <CardContent>
        <Typography variant="subtitle2" color="text.secondary" mb={2}>
          Credit Accounts
        </Typography>
        {data.map((acc, idx) => (
          <Box key={idx} sx={{ mb: 2 }}>
            <Typography variant="body2" fontWeight="bold">{acc.bank}</Typography>
            <Typography variant="caption" color="text.secondary">Balance: ${acc.balance.toLocaleString()}</Typography><br />
            <Typography variant="caption" color="text.secondary">Limit: ${acc.limit.toLocaleString()}</Typography><br />
            <Typography variant="caption" color="text.secondary">APR: {acc.apr}</Typography><br />
            <Typography variant="caption" color="text.secondary">Opened: {acc.opened}</Typography><br />
            <Typography variant="caption" color="text.secondary">Status: {acc.status}</Typography>
            {idx < data.length - 1 && <Divider sx={{ mt: 1, mb: 2 }} />}
          </Box>
        ))}
      </CardContent>
    </Card>
  );
}
